export default class UserRole {

    static SUPERADMIN = 31000; // Superadministrador
    static ADMIN = 51000; // Administrador
    static CONTRACTORS_MANAGER = 41000; // Gestor contratistas
    static OUTSOURCES_MANAGER = 41001; // Gestor subcontratistas
    static OUTSOURCES_VIEWER = 41002; // Consulta
    static LISTERIA_MANAGER = 52000 // Gestor de listería

}



// WEBPACK FOOTER //
// ./src/app/shared/model/UserRole.js